import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { openFloatingProgressSubject } from '../../../core/services/dialog-service';
import { BaseComponent } from '../../component-base';

@Component({
  selector: 'app-floating-progress',
  templateUrl: './floating-progress.component.html',
  styleUrl: './floating-progress.component.scss',
})
export class FloatingProgressComponent extends BaseComponent {
  public title?: string;
  public curr?: number;
  public max?: number;
  public icon?: string;

  readonly ref: ChangeDetectorRef = inject(ChangeDetectorRef);
  constructor() {
    super();
    openFloatingProgressSubject.subscribe(data => {
      this.title = data?.title;
      this.curr = data?.curr;
      this.max = data?.max;
      this.icon = data?.icon;
      this.ref.detectChanges();
    });
  }
}
